import jwtDecode from 'jwt-decode';

const resourceAliases = {
    holiday_gift_requests: 'form_entries',
    contact_forms: 'form_entries',
    quote_inquiries: 'form_entries',
    impacted_policies: 'impacting_policies',
};

export const Permissions = (resource, action) => {
    const targetResource = resourceAliases[resource] || resource;
    const userInfoStr = window.localStorage.getItem('user_info');
    if (userInfoStr) {
        try {
            const userInfo = JSON.parse(userInfoStr);
            const { permissions } = userInfo;

            if (permissions) {
                if (!permissions[targetResource]) {
                    return true;
                }

                return permissions[targetResource][action];
            }
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            // ignore
        }
    }

    const jwt = window.localStorage.getItem('jwt');
    if (jwt) {
        const decodedJWT = jwtDecode(jwt);

        if (decodedJWT && !decodedJWT.permissions) {
            // old jwt has no permissions
            return true;
        }

        const { permissions } = decodedJWT;

        if (!permissions[targetResource]) {
            // old jwt has no resource in permissions
            return true;
        }

        return permissions[targetResource][action];
    }

    return false;
};
